import { gql } from "apollo-boost";

export const GET_PIVOT_PROFILES = gql`
  query {
    allPivotProfiles {
      edges {
        node {
          profileSeqno
          profileName
          profileCategory
          repRows
          repCols
          repVals
          agregatorName
          rendererName
          colorder
          roworder
          valueFilter
          updateDate
          updateSource
        }
      }
    }
  }
`;
